<style scoped>
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}

.right-content {
  flex: 1;
  overflow: hidden;
}

.el-col-5 {
  width: 33%;
  margin-bottom: 15px;
}

.search-area-div {
  width: 80px;
}

.el-col-4 {
  width: 33%;
}

.payment-information {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  border: 1px solid #d2d2d3;
  border-radius: 4px;
  padding: 20px;
}

.pay-item {
  display: flex;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.pay-name {
  width: 100px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
  margin-right: 10px;
}

.pay-left {
  width: 100%;
}

.pay-right {
  width: 10%;
  /* flex-shrink: 0; */
}

/* 填报信息样式 */
.drawer-inform {
  font-size: 14px;
  display: flex;
  width: 100%;
  margin-bottom: 20px;
}

.drawer-inform-div {
  display: flex;
  width: 33.3%;
  margin-right: 20px;
  flex-shrink: 0;
}

.inform-title {
  /* display: block; */
  flex-shrink: 0;
  width: 65px;
  text-align: right;
  color: #bcbec2;
  margin-right: 10px;
}

.inform-content {
  display: block;
  color: #333;
  word-break: break-all;
  white-space: normal;
}

.total-content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.payment {
  display: flex;
}
</style>
<template>
  <div class="content" style="display: flex">
    <div class="left-content">
      <el-table :data="tableData1" style="width: 100%" @row-click="getDetails">
        <el-table-column prop="date" label="序号" width="70"> </el-table-column>
        <el-table-column prop="name" label="医院"> </el-table-column>
      </el-table>
    </div>
    <keep-alive>

      <div class="right-content">
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="5">
              <div class="search-area-div">年度：</div>
              <el-date-picker class="w70f" v-model="page.year" type="year" placeholder="选择年" :clearable="true">
              </el-date-picker>
            </el-col>
            <el-col :span="5">
              <div class="search-area-div">月份：</div>
              <el-select class="w70f" v-model="page.month" placeholder="请选择" :clearable="true">
                <el-option v-for="item in optionsMonth" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <div class="search-area-div">供应商：</div>
              <el-input class="w70f" v-model="page.supplierName" placeholder="请输入" type="text"
                :clearable="true"></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="5">
              <div class="search-area-div">付款状态：</div>
              <el-select class="w70f" v-model="page.paymentState" placeholder="请选择" :clearable="true">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <div class="search-area-div">开票状态：</div>
              <el-select class="w70f" v-model="page.invoiceState" placeholder="请选择" :clearable="true">
                <el-option v-for="item in invoiceStateOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5" class="t-right">
              <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="button-area">
          <el-button @click="batchReportOnArrival">到账批量填报</el-button>
          <el-button @click="fillIninvoicesInBulk">发票批量填报</el-button>
          <el-button @click="toFillInTheAccountExport">导出</el-button>
          <!-- <el-button @click="toTotal">汇总统计</el-button> -->
        </div>
        <div class="back-color-fff p16" style="padding: 16px">
          <el-table :data="fillReceiptData" style="width: 100%; margin-bottom: 10px" border v-loading="loading"
            @selection-change="handleSelectionChange" ref="multipleTable">
            <el-table-column type="selection" width="40" header-align="center" align="center"
              fixed="left"></el-table-column>
            <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
              <template slot-scope="scope">
                <!-- {{ scope.$index + 1 }} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="supplierName" label="供应商" header-align="center" align="left" min-width="250"
              fixed="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="year" label="年度" header-align="center" align="center" width="70"> </el-table-column>
            <el-table-column prop="month" label="月份" header-align="center" align="center" width="60">
            </el-table-column>
            <el-table-column prop="settleBillno" label="结算单号" header-align="center" align="center" width="200">
            </el-table-column>
            <el-table-column prop="payableAmount" label="应付款" header-align="center" align="right" width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.payableAmount | numDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="paymentState" label="付款状态" header-align="center" align="center" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.paymentState | getPaymentState }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="receiptAmount" label="实际到账" header-align="center" align="right" width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.receiptAmount | numDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="欠款" header-align="center" align="right" width="110">
              <template slot-scope="scope">
                <span>{{ (scope.row.payableAmount - scope.row.receiptAmount) | numDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceState" label="开票状态" header-align="center" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.row.invoiceState | getInvoiceState }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开票金额" header-align="center" align="right" width="110" prop="invoiceAmount">
              <template slot-scope="scope">
                <span>{{ scope.row.invoiceAmount | numDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="待开票" header-align="center" align="right" width="110">
              <template slot-scope="scope">
                <span>{{ (scope.row.receiptAmount - scope.row.invoiceAmount) | numDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="350" fixed="right">
              <template slot-scope="scope">
                <a class="txt-color" @click="getCostDetail(scope.row)">费用详情 | </a>
                <a class="txt-color" @click="getArriveFill(scope.row, scope.$index)">到账填报 | </a>
                <a class="txt-color" @click="getInvoiceFill(scope.row, scope.$index)">发票填报 | </a>
                <a class="txt-color" @click="getFillDetail(scope.row)">填报详情 | </a>
                <a class="txt-color" @click="getContractDetail(scope.row)">合同详情</a>
              </template>
            </el-table-column>
          </el-table>
          <div class="total-content">
            <div>已选欠款总金额<el-input class="w115 ml10" v-model="totalAmountOwed" readonly type="text"></el-input>
            </div>
            <div>已选待开票总金额<el-input class="w115 ml10" v-model="totalAmountToBeInvoiced" readonly type="text"></el-input>
            </div>
          </div>
        </div>


        <el-pagination class="pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
          :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
      </div>
    </keep-alive>

    <!-- 到账填报抽屉 -->
    <arrive-fill ref="arrive" :arrive="arriveFillData" @refreshData="getData()"></arrive-fill>
    <!-- 批量到账填报抽屉 -->
    <batch-arrive-fill ref="batchArrive" :arrive="batchArriveFillData" @refreshData="getData()"></batch-arrive-fill>
    <!-- 发票填报抽屉 -->
    <invoice-fill ref="invoice" :invoice="invoiceFillData" @refreshData="getData()"></invoice-fill>
    <!-- 批量发票填报抽屉 -->
    <batch-invoice-fill ref="batchInvoice" :invoice="batchInvoiceFillData" @refreshData="getData()"></batch-invoice-fill>
    <!-- 填报详情抽屉 -->
    <fill-detail ref="fillDetail" :fillDetailData="fillDetailData"></fill-detail>
    <!-- 合同详情抽屉 -->
    <contract-detail ref="contractDetail" :contractDetailData="contractDetailData"></contract-detail>
  </div>
</template>
<script>
import ArriveFill from '@/components/operatingDrawer/arriveFill';
import BatchArriveFill from '@/components/operatingDrawer/batchArriveFill';
import InvoiceFill from '@/components/operatingDrawer/invoiceFill';
import BatchInvoiceFill from '@/components/operatingDrawer/batchInvoiceFill';
import FillDetail from '@/components/operatingDrawer/fillDetail';
import ContractDetail from '@/components/operatingDrawer/contractDetail';
export default {
  data() {
    return {
      arriveData: [{ money: '', date: '' }],
      performanceData: [],
      fillReceiptData: [],
      options: [
        {
          value: 'Y',
          label: '已付清',
        },
        {
          value: 'P',
          label: '未付清',
        },
        {
          value: 'N',
          label: '未付',
        },
      ],
      optionsMonth: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
      ],
      invoiceStateOptions: [
        {
          value: '1',
          label: '全额已开',
        },
        {
          value: '2',
          label: '部分已开',
        },
        {
          value: '3',
          label: '未开票',
        },
      ],
      value: '',
      direction: 'rtl',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: 'd2256eb2892d4887a02c6ef9a4beeffb',
        year: '',
        month: '',
        invoiceState: '',
        // invoiceState: '',
        supplierName: '',
        paymentState: 'N',
        // paymentState: '',
      },
      tableData1: [
        {
          date: '1',
          name: '常熟市中医院',
        },
      ],

      arriveFillData: '',
      invoiceFillData: '',
      batchArriveFillData: '',
      batchInvoiceFillData: '',
      fillDetailData: '',
      contractDetailData: '',
      current: -1,
      loading: false,
      multipleSelection: []
    };
  },
  created() {
    // 列表
    this.getData();
  },
  watch: {
    fillReceiptData: {
      handler(newValue, oldValue) {
        console.log(newValue);
        // this.current >= 0 &&
        //   (this.arriveFillData = newValue[this.current]) &&
        //   (this.invoiceFillData = newValue[this.current]);
        // this.current >= 0 && (this.invoiceFillData = newValue[this.current]);
      },
      deep: true,
    },
    page: {
      handler(newValue, oldValue) {
        if (newValue.year == null) {
          this.page.year = '';
        }
      },
      deep: true,
    },
  },
  methods: {
    //获取整行信息
    getDetails(row) {
      console.log(row);
    },
    arriveDel(index) {
      let self = this;
      self.arriveData.splice(index, 1);
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: self.$store.state.medGuid,
        month: '',
        year: '',
        invoiceState: '',
        supplierName: '',
        paymentState: '',
      };
      self.getData();
    },
    //跳转统计
    toTotal() {
      let self = this;
      self.$router.push('/statisticalReport');
    },
    //搜索
    searchData() {
      let self = this;
      self.getData();
    },
    //获取数据列表
    getData() {
      let self = this;
      self.loading = true;
      let invoiceState = self.page.invoiceState;
      let medGuid = self.$store.state.medGuid;
      let pageIndex = self.page.pageIndex;
      let pageSize = self.page.pageSize;
      let supplierName = self.page.supplierName;
      let paymentState = self.page.paymentState;
      let month = self.page.month;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.api
        .get(
          `/ms-data-business-service/operating-costs/get-operating-costs-list?invoiceState=` +
          invoiceState +
          `&isAck=Y` +
          `&medGuid=` +
          medGuid +
          `&month=` +
          month +
          `&paymentState=` +
          paymentState +
          `&supplierName=` +
          supplierName +
          `&year=` +
          year +
          `&pageIndex=` +
          pageIndex +
          `&pageSize=` +
          pageSize
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.loading = false;
            self.fillReceiptData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getCostDetail(row) {
      let self = this;
      let query = { guid: row.supplierGuid, settleBillno: row.settleBillno, yearMonth: row.year + '-' + row.month, year: row.year, month: row.month, medName: row.medName, supplierName: row.supplierName };
      let queryData = JSON.stringify(query);
      self.$router.push({
        path: '/fillReceipt/expenseConfirmationDetail',
        query: { queryData: queryData }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    // 全选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //到账填报
    getArriveFill(row, index) {
      let self = this;
      self.current = index;
      self.$refs.arrive.title = '到账填报'
      self.$refs.arrive.showArrive = true;
      self.$refs.arrive.getArriveDetail(row.guid);
      self.arriveFillData = row;
    },
    //发票填报
    getInvoiceFill(row, index) {
      let self = this;
      self.current = index;
      self.$refs.invoice.showInvoice = true;
      self.$refs.invoice.getInvoice(row.guid);
      self.invoiceFillData = row;
      console.log(row);
    },
    //到账批量填报
    batchReportOnArrival() {
      let arr = this.$refs.multipleTable.selection
      if (arr.length == 0) {
        this.$message.error('请至少选择一条数据');
        return
      }
      if (arr.some(item => item.supplierGuid != arr[0].supplierGuid)) {
        this.$message.error('只能对同一供应商进行批量操作');
        return
      }
      this.batchArriveFillData = arr
      this.$refs.batchArrive.showArrive = true;
    },
    // 发票批量填报
    fillIninvoicesInBulk() {
      let arr = this.$refs.multipleTable.selection
      if (arr.length == 0) {
        this.$message.error('请至少选择一条数据');
        return
      }
      if (arr.some(item => item.supplierGuid != arr[0].supplierGuid)) {
        this.$message.error('只能对同一供应商进行批量操作');
        return
      }
      this.batchInvoiceFillData = arr
      this.$refs.batchInvoice.showInvoice = true;
    },
    //填报详情
    getFillDetail(row) {
      let self = this;
      self.$refs.fillDetail.showFillDetail = true;
      self.$refs.fillDetail.getInvoiceDetail(row.guid);
      self.fillDetailData = row;
      console.log(row);
    },
    //合同详情
    getContractDetail(row) {
      let self = this;
      self.$refs.contractDetail.showContractDetail = true;
      self.$refs.contractDetail.getContractData(row.supplierGuid);
      self.contractDetailData = row;
      console.log(row);
    },
    //导出
    toFillInTheAccountExport() {
      let medGuid = this.$store.state.medGuid;
      let year = this.page.year && this.$moment(this.page.year).format('yyyy');
      let { month, supplierName, paymentState, invoiceState } = this.page;
      this.loading = true;
      this.api
        .post(
          `/ms-data-business-service/operating-costs/export?` +
          `medGuid=` +
          medGuid +
          `&supplierName=` +
          supplierName +
          `&year=` +
          year +
          `&month=` +
          month +
          `&paymentState=` +
          paymentState +
          `&invoiceState=` +
          invoiceState,
        ).then(res => {
          this.loading = false
          if (res.data.code == '00000') {
            this.api
              .postJsonD(`ms-common-admin-cloud-service/excel/export`, res.data.data).then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let fileName = '运营费到账填报';
                let objectUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download = fileName;
                link.href = objectUrl;
                link.click();
              })
          }
        })
    },
  },
  computed: {
    // 欠款总额
    totalAmountOwed() {
      return this.multipleSelection.reduce((preValue, curValue, index, array) =>
        preValue + (curValue.payableAmount - curValue.receiptAmount)
        , 0).toFixed(2)
    },
    // 待开票总额
    totalAmountToBeInvoiced() {
      return this.multipleSelection.reduce((preValue, curValue, index, array) =>
        preValue + (curValue.receiptAmount - curValue.invoiceAmount)
        , 0).toFixed(2)
    },
  },
  components: {
    ArriveFill,
    BatchArriveFill,
    InvoiceFill,
    BatchInvoiceFill,
    FillDetail,
    ContractDetail,
  },
};
</script>